export default __webpack_public_path__ + "static/media/spoolSheets1.e9357707.jpg";